<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="员工管理"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <template #right>
                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>
            </template>
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.3rem ">
        <!-- button -->
        <div>
          <div class="button-top">
                <van-button type="primary">添加员工</van-button>
                <van-button type="info">刷新列表</van-button>
           </div>
               <van-cell value="员工列表" />
        <!--内容 start-->
            <div style="margin-top:0.02rem">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad" 
                    >

                <div v-for="(admin,index) in list" :key="index">
                        <van-cell  @click="to_transaction_details(admin.pay_id)">
                        <van-row gutter="20">
                            <van-col span="15">
                                <van-row gutter="20">
                                
                                    <van-col span="24" class="title_font">{{admin.trans_subject}}元</van-col>
                                    <van-col span="24" class="date_font">{{admin.trans_oktime}}</van-col>
                                </van-row>
                            </van-col>
                            <van-col span="6">
                                <van-row gutter="20">
                                    <van-col span="24" class="title_font">{{admin.trans_type=="wxpay"?"微信":"支付宝"}}</van-col>
                                    <van-col span="24" class="title_font">{{admin.total_fee}}元</van-col>
                                    
                                </van-row>
                            </van-col>
                            <van-col span="3"  :class="admin.trans_status==3?'green_like':'green_font'" class="green_font">{{admin.trans_status==3?"退款":"消费"}}</van-col>
                        </van-row>
                    </van-cell>

                    </div>
                </van-list>
            </div>
        </div>
       
      

        </div>
        <!--内容 end-->
    </div>
</template>

<script>

    export default {
        name: "StaffManagement", //员工管理
        data(){
            return{
                list: [],
                loading: false,
                finished: false,
                // page:0,
                // num:10
              
            }
        },
        methods: {
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/MerchantInformation');
            },
            // 右侧icon跳转至商户首页
            onClickRight() {
                // 返回商户首页
                this.$router.push('/MerchantHomepage');
            },
             // 列表
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                // this.page+=1;
                //  this.tive1()
                
            },
                   //根据门店选择发送请求
        //   tive1(){
        //         var that=this
        //          this.$http.get('/wechat/api.order/get_order', {
        //             params: {
        //                 merchant_id:window.sessionStorage.getItem("commercialId"),
        //                 start_date:"2020-07-07",
        //                 store_id:"",
        //                 end_date:"2020-07-07",
        //                 page:this.page,
        //                 num:this.num
        //             }
        //         }).then(response => {
        //             console.log("1");
        //           that.loading=false;
        //       if (response.data.data.length) {
        //            that.list.push(...response.data.data);
        //            that.finished = false;
        //             } else{
        //              that.finished = true;
        //             }
                  
        //         }) 
        //     },
        },
        mounted(){

        }
    }
</script>

<style scoped>

    .button-top{
        /* border: solid 1px red; */
        display: flex;
        justify-content: space-around;
        background-color: white;
    }
    .van-button{
        width: 3rem;
        margin: 0.1rem 0;
    }

</style>